import { find } from 'lodash';
import React from 'react';
import { useIntl } from 'react-intl';
import timeZones from '../core/time-zone-picker/zone/zones';
import { useLocalizationContext } from './LocalizationProvider';
import toDateTime from './util/toDateTime';

export const useFormat = () => {
  const intl = useIntl();
  const { timeZone } = useLocalizationContext();

  const dateOptions = React.useMemo(
    () => ({
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      weekday: 'short',
      timeZone,
    }),
    [timeZone]
  );

  const timeOptions = React.useMemo(
    () => ({
      hour: '2-digit',
      minute: '2-digit',
      timeZone,
    }),
    [timeZone]
  );

  const formatLongDateTime = React.useCallback(
    (isoDateString, timeZoneOverride) => {
      try {
        const dateTime = toDateTime(isoDateString, timeZoneOverride || timeZone);

        const date = intl.formatDate(dateTime.toJSDate(), dateOptions);
        const time = intl.formatDate(dateTime.toJSDate(), timeOptions);

        const tzRecord = find(timeZones, { name: timeZone });

        const tz = dateTime?.setLocale?.(tzRecord?.locale)?.toFormat?.('ZZZZ');

        return `${date} ${time} (${tz})`;
      } catch (e) {
        console.error(e);
        return '';
      }
    },
    [dateOptions, intl, timeOptions, timeZone]
  );

  return {
    formatLongDateTime,
  };
};
